import inViewport from '../../../../javascripts/helpers/inViewport';

const stageQuestions = document.querySelector('[data-js-module="o-stage-questions"]');
const init = () => inViewport(stageQuestions, 0.3);

if (stageQuestions) init();
